import { ServiceTierGrid } from "./ServiceTierGrid";

export const Services = () => {
  return (
    <section id="services" className="py-16 bg-section-alt">
      <div className="container mx-auto px-4">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold mb-4 text-primary">
            Our Service Tiers
          </h2>
          <p className="text-lg text-muted-foreground max-w-2xl mx-auto">
            Choose the perfect plan for your pool maintenance needs, from basic care to luxury concierge services
          </p>
        </div>

        <ServiceTierGrid variant="standard" showCompareButton={true} />
      </div>
    </section>
  );
};